import { setStoredLocale } from 'common/storage/localeStorage';
import { useAppDispatch, useAppSelector } from 'src/core/redux-utils';

import intlSelectors from './intlSelectors';
import { fetchLocaleRequest } from './intlSlice';

import type { SupportedLocale } from './intlTypes';

// Persisting belongs with the dispatch so a language the user picked is remembered
// wherever they pick it, while a browser-negotiated locale stays unpersisted
const useLocaleChange = () => {
  const dispatch = useAppDispatch();
  const { locale } = useAppSelector(intlSelectors);

  const changeLocale = (nextLocale: SupportedLocale) => {
    if (nextLocale === locale) {
      return;
    }
    setStoredLocale(nextLocale);
    dispatch(fetchLocaleRequest(nextLocale));
  };

  return { locale, changeLocale };
};

export default useLocaleChange;
